import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Instagram, Youtube } from 'lucide-react';
import { toast } from 'sonner';
import { primaryNavItems } from '../data/navLinks';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleNewsletterSubmit = async (event) => {
    event.preventDefault();
    if (!email.trim()) {
      toast.error('Prosím zadajte e‑mail.');
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await fetch('/api/ecomail-newsletter', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim() }),
      });

      if (!response.ok) {
        const errorBody = await response.json().catch(() => ({}));
        throw new Error(errorBody?.error || 'Nepodarilo sa odoslať e‑mail.');
      }

      toast.success('Ďakujeme! Ste prihlásený do newslettera.');
      setEmail('');
    } catch (error) {
      toast.error(error.message || 'Nastala chyba. Skúste to prosím znova.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <footer className="bg-brand-dark-blue text-white mt-auto">
      <div className="container mx-auto px-4 pt-24 pb-16">
        <div className="grid grid-cols-1 pt-8 md:grid-cols-3 gap-12">
          {/* Logo Symbol */}
          <div className="text-center md:text-left">
            <img
              src="/symbol-2.svg"
              alt="Peto Sloboda Symbol"
              className="h-16 w-auto mx-auto md:mx-0 mb-4"
            />
            <p className="text-gray-400 text-sm">
              Osobná značka a projekt<br />Gramotnosť ako zbraň.
            </p>
          </div>

          {/* Menu */}
          <div>
            <h4 className="text-lg font-heading font-bold mb-4 text-white">Menu</h4>
            <ul className="space-y-2">
              {primaryNavItems.map((item) => (
                <li key={item.id}>
                  <Link
                    to={item.path}
                    className="text-gray-300 hover:text-brand-orange transition-colors"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/afrika"
                  className="text-gray-300 hover:text-brand-orange transition-colors"
                >
                  Afrika
                </Link>
              </li>
            </ul>
          </div>

          {/* Social + Newsletter */}
          <div>
            <h4 className="text-lg font-heading font-bold mb-4 text-white">Kontakt</h4>
            <div className="flex space-x-4 mb-6">
              <a href="https://www.linkedin.com/in/petosloboda/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-brand-orange transition-colors">
                <Linkedin size={24} />
              </a>
              <a href="https://www.instagram.com/petosloboda/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-brand-orange transition-colors">
                <Instagram size={24} />
              </a>
              <a href="https://www.youtube.com/@peto.sloboda" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-brand-orange transition-colors">
                <Youtube size={24} />
              </a>
            </div>

            <form className="flex flex-col sm:flex-row gap-2 min-w-0" onSubmit={handleNewsletterSubmit}>
              <input
                type="email"
                placeholder="Email"
                className="w-full min-w-0 flex-1 px-3 py-2.5 rounded-lg text-gray-900 text-sm focus:outline-none focus:ring-2 focus:ring-brand-orange"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                required
              />
              <button
                type="submit"
                className="shrink-0 bg-brand-orange hover:bg-orange-600 text-white font-semibold px-4 py-2.5 rounded-lg transition-colors text-sm disabled:opacity-60 min-h-[44px] w-full sm:w-auto"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Odosielam…' : 'Prihlasit'}
              </button>
            </form>
            <div className="mt-3 flex gap-3 text-xs text-gray-400">
              <Link to="/gdpr" className="hover:text-brand-orange transition-colors">GDPR</Link>
              <Link to="/cookies" className="hover:text-brand-orange transition-colors">Cookies</Link>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-gray-700 mt-12 pt-8 text-center">
          <p className="text-gray-400 text-sm leading-relaxed">
            © {currentYear} Peťo Sloboda - Osobná značka a projekt Gramotnosť ako zbraň.<br />
            Vytvorené s dôrazom na integritu, hodnoty a poriadok v majetku.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
